// extracted by css-extract-rspack-plugin
export default {"suggestionPaper":"kelxD"};